module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }]
  }, [_c('label', [_vm._v("\n        " + _vm._s(_vm.t(_vm.displayName)) + "\n    ")]), _vm._v(" "), _c('dateRange-picker-pl', {
    staticStyle: {
      "width": "100%",
      "min-width": "100%"
    },
    attrs: {
      "min-date": _vm.minDate,
      "max-date": _vm.maxDate
    },
    on: {
      "update": _vm.onUpdate
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [(_vm.isValueSet) ? _c('div', {
    attrs: {
      "slot": "input picker"
    },
    slot: "input picker"
  }, [_vm._v("\n            " + _vm._s(_vm.value.startDate) + " - " + _vm._s(_vm.value.endDate) + "\n        ")]) : _c('div', {
    attrs: {
      "slot": "input picker"
    },
    slot: "input picker"
  }, [_vm._v(_vm._s(_vm.t('Select dates')))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0fdefb73!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/filter/DateRangeComponent.vue
// module id = 1236
// module chunks = 2